import React from 'react'
import '../ChatYesNo/ChatYesNo.css'
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

interface IYesNoProps {
    clickYes: () => void;
    clickNo: () => void;
}
const ChatYesNo = ({clickYes, clickNo}: IYesNoProps) => {
    return (
        <div className={'user-yes-no-input'}>
            <Box display="flex" justifyContent="flex-start">
                <Button variant="contained" color="primary" onClick={clickYes}>
                    Yes
                </Button>
                <Button variant="contained" color="error" onClick={clickNo} style={{ marginLeft: 8 }}>
                    No
                </Button>
            </Box>
        </div>
    )
}

export default ChatYesNo;